var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleRightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8C2FEFA9-2C9C-4602-994D-2A46F6F3220C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-276.000000, -831.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(276.000000, 831.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E6E6E6",
    fill: "#FFFFFF",
    cx: 25,
    cy: 25,
    r: 24.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.720517,30 C25.0694669,30 25.4184168,29.8836834 25.6510501,29.6510501 L32.0484653,23.2536349 C32.2810985,23.0210016 32.3974152,22.6720517 32.3974152,22.3231018 C32.3974152,21.9741519 32.2810985,21.6252019 32.0484653,21.3925687 C31.815832,21.1599354 31.4668821,21.0436187 31.1179321,21.0436187 C30.7689822,21.0436187 30.4200323,21.1599354 30.187399,21.3925687 L24.720517,26.8594507 L19.2536349,21.3925687 L19.2536349,21.3925687 C18.904685,21.0436187 18.4394184,20.9273021 17.9741519,21.0436187 C17.5088853,21.1599354 17.1599354,21.5088853 17.0436187,21.9741519 C16.9273021,22.4394184 17.0436187,22.904685 17.3925687,23.2536349 L23.7899838,29.6510501 C24.0226171,29.8836834 24.371567,30 24.720517,30 L24.720517,30 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.504661923,
    transform: "translate(24.698708, 25.500000) rotate(-90.000000) translate(-24.698708, -25.500000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRightIcon);
export default __webpack_public_path__ + "static/media/circle-right-icon.1e870f015b00e7ce9a1938dd652b4de5.svg";
export { ForwardRef as ReactComponent };